'use client'

import { useEffect,useState } from 'react'

type ModuleAnalyticsProps = {
  userId: string
}

export function ModuleAnalytics({ userId: _userId }: ModuleAnalyticsProps) {
  const [analytics, setAnalytics] = useState({
    totalSessions: 0,
    totalTime: 0,
    modulesUsed: 0
  })

  useEffect(() => {
    // Mock analytics data for now
    setTimeout(() => {
      setAnalytics({
        totalSessions: 12,
        totalTime: 240, // minutes
        modulesUsed: 3
      });
    }, 0);
  }, [])

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-foreground-default">Usage Analytics</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-background-muted border border-border rounded-lg p-4">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-3">
              <span className="text-primary-foreground text-sm font-bold">📊</span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-muted">Total Sessions</p>
              <p className="text-2xl font-bold text-foreground-default">{analytics.totalSessions}</p>
            </div>
          </div>
        </div>

        <div className="bg-background-muted border border-border rounded-lg p-4">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-success-default rounded-full flex items-center justify-center mr-3">
              <span className="text-success-foreground text-sm font-bold">⏱️</span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-muted">Total Time</p>
              <p className="text-2xl font-bold text-foreground-default">{analytics.totalTime}m</p>
            </div>
          </div>
        </div>

        <div className="bg-background-muted border border-border rounded-lg p-4">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-warning-default rounded-full flex items-center justify-center mr-3">
              <span className="text-warning-foreground text-sm font-bold">🔧</span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-muted">Modules Used</p>
              <p className="text-2xl font-bold text-foreground-default">{analytics.modulesUsed}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-background-default border border-border rounded-lg p-4">
        <h4 className="text-sm font-medium text-foreground-default mb-2">Recent Activity</h4>
        <p className="text-sm text-foreground-muted">Analytics data will appear here as you use the platform.</p>
      </div>
    </div>
  )
}